import React, { useState } from "react";
import './TablaBitacoras.scss'
import Button from "../../atoms/Button/Button";
import ButtonGris from "../../atoms/ButtonGris/ButtonGris";
import InputLista from "../../atoms/InputLista/InputLista";
import TextArea from "../../atoms/TextArea/TextArea";
import { desconfirmar } from "./TablaBitacorasntegracion";

const ModalDesconfirmarBitacora = ({data,setShowDesconfirmarBitacora})=>{
    const [motivo,setMotivo] = useState()
    const submit = ()=>{
        const dataSend = {
            id_bitacora : data.bitacora,
            motivo:motivo
        } 
        desconfirmar(dataSend,setShowDesconfirmarBitacora)
    }
    return (
        <div className="modalContorn">
            <div className="modal">
                <div className="titleN">Registrar incidente en bitácora : {data.bitacora}</div>
                <div className="titleN">{data.ruta}</div>
                <div className="titleN">{data.nombre}</div>
                <div className="margen">
                    <TextArea value={motivo} onChange={(e)=>{setMotivo(e.target.value)}} titulo={"Motivo"} className={"textAreaClass"}></TextArea>
                    {/* <InputLista titulo={"Incidente"}></InputLista> */}
    
                    <div className="containerButtons">
                        <ButtonGris onClick={() => { setShowDesconfirmarBitacora(null) }}>Cancelar</ButtonGris>
                        <Button disabled={motivo?false:true} onClick={()=>{submit()}}>Registrar</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ModalDesconfirmarBitacora